import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "campaign-url-architect",
  title: "Campaign URL Architect",
  description:
    "Build clean UTM-tagged campaign URLs, preview every parameter, and keep a local history for reuse.",
  category: "SEO",
} satisfies ToolMeta;
